import React from 'react';
import "./loading.scss";

const Loading = () => {
  return (
    <div id='spinner-shape'>
        <div className="spinner"></div>
    </div>
  )
}

export default Loading